import React, { useEffect, useState } from "react";
import CustomInput from "../../CustomInput";
import { FieldValues, useForm } from "react-hook-form";
import { dashboard_invoice_approve } from "../../../assets/images";
import { useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CustomerOrderEditData,
  // OrderEditData,
} from "../../../types";
import SuccessModal from "../../SuccessModal";
import moment from "moment";
import ConfirmationModal from "../../ConfirmationModal";
import { toast } from "react-toastify";
import { trackEvent } from "../../../services/events";
import ReactPixel from "react-facebook-pixel";
import OrderEditDateTimePicker from "../../OrderEditDateTimePicker";

interface LocationData {
  latitude: number;
  longitude: number;
}

interface RecollectionLocationData {
  Recollectionlatitude: number;
  Recollectionlongitude: number;
}

const CustomerorderDetailsEdit = () => {
  const location = useLocation();
  const OrderId = new URLSearchParams(location.search).get("OrderId");
  const buttonExtend = location.state?.buttonExtend || false;
  const [status, setStatus] = useState<string>("");
  // const [selectedCar, setSelectedCar] = useState("");
  const [selectedpickupby, setSelectedpickupby] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [suggestionClicked, setSuggestionClicked] = useState(false);

  const [addressSuggestions, setAddressSuggestions] = useState<string[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<LocationData>({
    latitude: 0,
    longitude: 0,
  });
  const [selectedRecollectionLocation, setSelectedRecollectionLocation] =
    useState<RecollectionLocationData>({
      Recollectionlatitude: 0,
      Recollectionlongitude: 0,
    });

  const [recollectionSearchQuery, setRecollectionSearchQuery] =
    useState<string>("");
  const [recollectionAddressSuggestions, setRecollectionAddressSuggestions] =
    useState<string[]>([]);
  const [recollectionSuggestionClicked, setRecollectionSuggestionClicked] =
    useState(false);
  const [daysModificationType, setDaysModificationType] = useState<
    "EXTENSION" | "REDUCE" | null
  >(null);
  // const [modifiedDays, setModifiedDays] = useState<string>("");

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showPaymentConfirmModal, setShowPaymentConfirmModal] = useState(false);
  const [paymentData, setPaymentData] = useState<any>(null);
  const navigate = useNavigate();

  // const [comments, setComments] = useState("");

  const {
    control,
    setValue,
    getValues,
    formState: { isValid },
  } = useForm({ mode: "onChange" });
  const { data: editOrderDetails, isLoading } = useQuery({
    queryKey: ["editOrderDetails", OrderId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URL.CUSTOMER_ORDER_DETAILS}/${OrderId}/details`,
        {
          headers: {
            location: "0,0",
            language: "english",
          },
        }
      );
      return response.data;
    },
  });

  useEffect(() => {
    const trackPageLoad = async () => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("ViewContent", {
        content_type: "page",
        content_name: "Order Edit Screen",
        content_category: "OrderHistory",
        order_id: OrderId,
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_OrderHistoryOrderEditScreen",
          app: "Kirkos_OrderHistoryOrderEditScreen_App",
        },
        event_category: "OrderHistory_Info",
        module: "OrderHistory",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  useEffect(() => {
    if (!isLoading && editOrderDetails) {
      const {
        delivery_start_time: delivery_start_time,
        delivery_end_time: delivery_end_time,
        rental_days: rental_days,
        delivery_preferred_time: delivery_preferred_time,
        delivered_by: delivered_by,
        delivery_date: delivery_date,
        delivery_location,
        recollection_location,
        products,
      } = editOrderDetails || {};
      const {
        address: address,
        latitude: latitude,
        longitude: longitude,
      } = delivery_location || {};
      const {
        address: recollectionAddress,
        latitude: recollectionLatitude,
        longitude: recollectionLongitude,
      } = recollection_location || {};
      const {
        productName: productName,
        babySeatAmount: babySeatAmount,
        additionalDriverAmount: additionalDriverAmount,
        windShieldProtection: windShieldProtection,
        paiInsuranceAmount: paiInsuranceAmount,
        scdwAmount: scdwAmount,
      } = products[0] || {};

      setValue("StartSlotTime", delivery_start_time);
      setValue("EndSlotTime", delivery_end_time);

      setValue("DeliveryTime", delivery_preferred_time);
      setValue("PickupBy", delivered_by);

      const formattedDateTime =
        moment(delivery_date).format("YYYY-MM-DDTHH:mm");
      const formattedRecollectionDateTime = moment(
        editOrderDetails?.recollection_date
      ).format("YYYY-MM-DDTHH:mm");

      setDateTime(formattedDateTime);
      setRecollectionDateTime(formattedRecollectionDateTime);
      console.log("date issue check", formattedDateTime);
      setValue("ProductName", products[0]?.productName);
      setValue("Location", address);
      setValue("Latitude", latitude);
      setValue("Longitude", longitude);
      setValue("RecollectionLocation", recollectionAddress);
      setValue("RecollectionLatitude", recollectionLatitude);
      setValue("RecollectionLongitude", recollectionLongitude);
      setValue("selectedCar", productName);
      setValue("PickedUp", delivered_by);
      setSelectedpickupby(delivered_by);
    }
  }, [editOrderDetails]);

  useEffect(() => {
    if (editOrderDetails?.delivery_location) {
      const { latitude, longitude } = editOrderDetails?.delivery_location;

      setSelectedLocation((prevLocation) =>
        prevLocation.latitude !== latitude ||
          prevLocation.longitude !== longitude
          ? { latitude, longitude }
          : prevLocation
      );
    }
  }, [editOrderDetails?.delivery_location]);
  useEffect(() => {
    if (editOrderDetails?.recollection_location) {
      const { recollectionLatitude, recollectionLongitude } =
        editOrderDetails?.recollection_location;

      setSelectedRecollectionLocation((prevLocation) =>
        prevLocation.Recollectionlatitude !== recollectionLatitude ||
          prevLocation.Recollectionlongitude !== recollectionLongitude
          ? {
            Recollectionlatitude: recollectionLatitude,
            Recollectionlongitude: recollectionLongitude,
          }
          : prevLocation
      );
    }
  }, [editOrderDetails?.recollection_location]);

  const formatDate = (isoDate: any) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // const formatTime = (dateTimeString: string) => {
  //   const date = new Date(dateTimeString);
  //   return date.toLocaleTimeString([], {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hourCycle: "h23",
  //   });
  // };

  //--------------------------------------------------------
  // const handleDaysExtend = (value: string) => {
  //   setDaysModificationType("EXTENSION");
  //   setModifiedDays(value);
  // };

  // const handleDaysReduce = (value: string) => {
  //   setDaysModificationType("REDUCE");
  //   setModifiedDays(value);
  // };

  useEffect(() => {
    if (editOrderDetails) {
      setStatus(editOrderDetails.insurance_order ? "true" : "false");
    }
  }, [editOrderDetails]);

  //-------------------------------------------

  const handleInputChange = (value: string) => {
    setSearchQuery(value);
    setSuggestionClicked(false);
  };

  const fetchLocationName = async (searchQuery: string) => {
    const response = await fetch(
      `https:///nominatim.kirkos.ae/search.php?q=${searchQuery}&limit=5&format=json&addressdetails=1`
    );
    // console.log(response, "wowww");
    const data = await response.json();
    const suggestions = data.map((item: any) => item.display_name);
    setAddressSuggestions(suggestions);
    const locationName = data?.display_name;
    return locationName;
  };

  const { data: locationName } = useQuery<string>({
    queryKey: ["locationName", searchQuery],
    queryFn: () => fetchLocationName(searchQuery),
  });
  const handleSuggestionClick = async (selectedSuggestion: string) => {
    const response = await fetch(
      `https:///nominatim.kirkos.ae/search.php?q=${selectedSuggestion}&limit=5&format=json&addressdetails=1`
    );
    const data = await response.json();
    if (data.length > 0) {
      const { lat, lon } = data[0];
      setSelectedLocation({
        latitude: parseFloat(lat),
        longitude: parseFloat(lon),
      });
    }
    setValue("Location", selectedSuggestion);
    setAddressSuggestions([]);
    setSuggestionClicked(true);
  };

  //--------------------------------------------------------------------
  //===========================================================================

  const handleRecollectionInputChange = (value: string) => {
    setRecollectionSearchQuery(value);
    setRecollectionSuggestionClicked(false);
  };

  const fetchRecollectionLocationName = async (
    recollectionSearchQuery: string
  ) => {
    const response = await fetch(
      `https:///nominatim.kirkos.ae/search.php?q=${recollectionSearchQuery}&limit=5&format=json&addressdetails=1`
    );
    const data = await response.json();
    const suggestions = data.map((item: any) => item.display_name);
    setRecollectionAddressSuggestions(suggestions);
    return data[0]?.display_name;
  };

  const { data: recollectionLocationName } = useQuery<string>({
    queryKey: ["recollectionLocationName", recollectionSearchQuery],
    queryFn: () => fetchRecollectionLocationName(recollectionSearchQuery),
  });

  const handleRecollectionSuggestionClick = async (
    selectedRecollectionSuggestion: string
  ) => {
    const response = await fetch(
      `https:///nominatim.kirkos.ae/search.php?q=${selectedRecollectionSuggestion}&limit=5&format=json&addressdetails=1`
    );
    const data = await response.json();
    if (data.length > 0) {
      const { lat, lon } = data[0];
      setSelectedRecollectionLocation({
        Recollectionlatitude: parseFloat(lat),
        Recollectionlongitude: parseFloat(lon),
      });
    }
    setValue("RecollectionLocation", selectedRecollectionSuggestion);
    setRecollectionAddressSuggestions([]);
    setRecollectionSuggestionClicked(true);
  };

  //===========================================================================

  //------------------------------------------------------------------------------
  const accessToken = localStorage.getItem("access_token");

  // const decodeToken = (token: any) => {
  //   if (token) {
  //     return JSON.parse(atob(token.split(".")[1]));
  //   } else {
  //     return null;
  //   }
  // };
  // const decodedToken = decodeToken(accessToken);

  // const merchantId =
  //   decodedToken && decodedToken["merchant-id"]
  //     ? decodedToken["merchant-id"]
  //     : null;
  const handleUpdate = () => {

    const originalRecollection = moment(editOrderDetails?.recollection_date).format("YYYY-MM-DDTHH:mm");
    if (recollectionDateTime === originalRecollection) {
      toast.error("No recollection date changed", {
        position: "top-right",
      });
      return;
    }


    let {
      DeliveryDate: delivery_date,
      NumberofDays: extended_rental_days,
      PickupBy: pickup_by,
    }: FieldValues = getValues();

    const isoFormattedDate = `${dateTime}:00`;
    const isoFormattedRecollectionDate = `${recollectionDateTime}:00`;
    // const latitude = selectedLocation?.latitude;
    // const longitude = selectedLocation?.longitude;
    const recollectionLatitude =
      selectedRecollectionLocation?.Recollectionlatitude;
    const recollectionLongitude =
      selectedRecollectionLocation?.Recollectionlongitude;

    //---------------------------------------

    const datePart = dateTime ? dateTime.split("T")[0] : "";
    let startTime = "";
    let endTime = "";
    // if (selectedSlot) {
    //   const slotParts = selectedSlot.split("-");
    //   if (slotParts.length === 2) {
    //     startTime = `${datePart}T${slotParts[0].trim()}`;
    //     endTime = `${datePart}T${slotParts[1].trim()}`;
    //   }
    // } else {
    //   const startSlotTime = getValues("StartSlotTime").split("T")[1];
    //   const endSlotTime = getValues("EndSlotTime").split("T")[1];
    //   startTime = `${datePart}T${startSlotTime}`;
    //   endTime = `${datePart}T${endSlotTime}`;
    // }

    if (selectedSlot) {
      const slotParts = selectedSlot.split("-");
      if (slotParts.length === 2) {
        startTime = `${datePart}T${slotParts[0].trim()}`;
        endTime = `${datePart}T${slotParts[1].trim()}`;
      }
    } else {
      const startSlotTime = getValues("StartSlotTime") || "T00:00:00";
      const endSlotTime = getValues("EndSlotTime") || "T00:00:00";

      const startSlotTimePart = startSlotTime.includes("T")
        ? startSlotTime.split("T")[1]
        : "";
      const endSlotTimePart = endSlotTime.includes("T")
        ? endSlotTime.split("T")[1]
        : "";

      startTime = `${datePart}T${startSlotTimePart}`;
      endTime = `${datePart}T${endSlotTimePart}`;
    }

    const userData: CustomerOrderEditData = {
      order_number: OrderId,
      ...(editOrderDetails?.orderStatus === "BOOKED"
        ? {
          delivery_date: isoFormattedDate,
          recollection_date: isoFormattedRecollectionDate,
          delivery_location: {
            address: getValues("Location"),
            city: "",
            street: "",
            district: "",
            state: "",
            country: "",
            pinCode: "",
            latitude: selectedLocation?.latitude
              ? selectedLocation.latitude.toString()
              : editOrderDetails?.delivery_location?.latitude,
            longitude: selectedLocation?.longitude
              ? selectedLocation.longitude.toString()
              : editOrderDetails?.delivery_location?.longitude,
            landMark: "",
          },
          recollection_location: {
            address: getValues("RecollectionLocation"),
            type: "",
            street: "",
            city: "",
            district: "",
            state: "",
            country: "",
            pinCode: "",
            latitude: recollectionLatitude
              ? recollectionLatitude.toString()
              : editOrderDetails?.recollection_location?.latitude,
            longitude: recollectionLongitude
              ? recollectionLongitude.toString()
              : editOrderDetails?.recollection_location?.longitude,
            landMark: "",
          },
        }
        : {
          rental_date: recollectionDateTime,
          ...(daysModificationType === "EXTENSION"
            ? { rental_day_key: "RENTAL_DAYS_EXTENSION" }
            : daysModificationType === "REDUCE"
              ? { rental_day_key: "RENTAL_DAYS_REDUCE" }
              : {}),
        }),
    };
    // console.log("button clicked");
    // console.log("userData:", userData);
    handleOrderEdit.mutate(userData);
  };

  const handleOrderEdit = useMutation({
    mutationFn: (userData: CustomerOrderEditData) =>
      axiosInstance.put(`${API_URL.CUSTOMER_ORDER_EDIT}`, userData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    onSuccess: async (successResponse) => {
      // console.log("successResponseproduct", successResponse);
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("CustomizeProduct", {
        content_type: "order_edit",
        content_name: "Order Edit Success",
        content_category: "OrderHistory",
        order_id: OrderId,
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_OrderHistoryOrderEdit_Success",
          app: "Kirkos_OrderHistoryOrderEdit_Success_App",
        },
        event_category: "OrderHistory_Info",
        module: "OrderHistory",
        payload: { status: "success", order_id: OrderId },
      });
      if (successResponse?.data) {
        if (
          successResponse?.data?.paymentInfo?.clientSecret
        ) {
          const orderPayments = successResponse?.data?.paymentInfo?.order_payments;
          const orderDetails = successResponse?.data?.paymentInfo?.order_details;
          const finalAmount = orderPayments?.amount || 0;

          // Store payment data and show confirmation modal
          setPaymentData({
            orderNumber: successResponse?.data?.orderView?.orderId,
            amount: finalAmount,
            clientSecret: successResponse?.data?.paymentInfo?.clientSecret,
            paymentMerchantInfo: orderPayments?.merchantAmount,
            paiInsuranceAmount: orderDetails?.paiInsuranceAmount || 0,
            scdwAmount: orderDetails?.scdwAmount || 0,
            cdwAmount: orderDetails?.cdwAmount || 0,
            additionalDriverAmount: orderDetails?.additionalDriverAmount || 0,
            windShieldProtection: orderDetails?.windShieldProtection || 0,
            babySeatAmount: orderDetails?.babySeatAmount || 0,
          });
          setShowPaymentConfirmModal(true);
        } else {
          setShowSuccessModal(true);
        }
      }
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        // alert(error?.data?.message);
        //setShowErrorModal(true);
      }
    },
  });

  //-------------------------------------------------------------------------
  // First, add a new state for recollection date
  const [dateTime, setDateTime] = useState("");
  const [recollectionDateTime, setRecollectionDateTime] = useState("");

  // Add handler for recollection date
  const handleRecollectionDateTimeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRecollectionDateTime(event.target.value);
  };

  // Update the recollection date input
  <div className="col-md-6 pt-3">
    <label className="form-label dashboard-poppins-font-style">
      Recollection Date
    </label>
    <div className="input-date-container">
      <input
        type="datetime-local"
        id="recollectionDatetime"
        value={recollectionDateTime}
        onChange={handleRecollectionDateTimeChange}
        min={dateTime} // Set minimum date to delivery date
        className="merchant-input-style-create-product"
      />
    </div>
  </div>;

  // Update the useEffect to set initial recollection date
  useEffect(() => {
    if (!isLoading && editOrderDetails) {
      const {
        delivery_start_time: delivery_start_time,
        delivery_end_time: delivery_end_time,
        rental_days: rental_days,
        delivery_preferred_time: delivery_preferred_time,
        delivered_by: delivered_by,
        delivery_date: delivery_date,
        delivery_location,
        recollection_location,
        products,
      } = editOrderDetails || {};
      const {
        address: address,
        latitude: latitude,
        longitude: longitude,
      } = delivery_location || {};
      const {
        address: recollectionAddress,
        latitude: recollectionLatitude,
        longitude: recollectionLongitude,
      } = recollection_location || {};
      const {
        productName: productName,
        babySeatAmount: babySeatAmount,
        additionalDriverAmount: additionalDriverAmount,
        windShieldProtection: windShieldProtection,
        paiInsuranceAmount: paiInsuranceAmount,
        scdwAmount: scdwAmount,
      } = products[0] || {};

      setValue("StartSlotTime", delivery_start_time);
      setValue("EndSlotTime", delivery_end_time);

      setValue("DeliveryTime", delivery_preferred_time);
      setValue("PickupBy", delivered_by);

      const formattedDateTime =
        moment(delivery_date).format("YYYY-MM-DDTHH:mm");
      const formattedRecollectionDateTime = moment(
        editOrderDetails?.recollection_date
      ).format("YYYY-MM-DDTHH:mm");

      setDateTime(formattedDateTime);
      setRecollectionDateTime(formattedRecollectionDateTime);
      // console.log("date issue check", formattedDateTime);
      setValue("ProductName", products[0]?.productName);
      setValue("Location", address);
      setValue("Latitude", latitude);
      setValue("Longitude", longitude);
      setValue("RecollectionLocation", recollectionAddress);
      setValue("RecollectionLatitude", recollectionLatitude);
      setValue("RecollectionLongitude", recollectionLongitude);
      setValue("selectedCar", productName);
      setValue("PickedUp", delivered_by);
      setSelectedpickupby(delivered_by);
    }
  }, [editOrderDetails]);

  useEffect(() => {
    if (editOrderDetails?.delivery_location) {
      const { latitude, longitude } = editOrderDetails?.delivery_location;

      setSelectedLocation((prevLocation) =>
        prevLocation.latitude !== latitude ||
          prevLocation.longitude !== longitude
          ? { latitude, longitude }
          : prevLocation
      );
    }
  }, [editOrderDetails?.delivery_location]);
  useEffect(() => {
    if (editOrderDetails?.recollection_location) {
      const { recollectionLatitude, recollectionLongitude } =
        editOrderDetails?.recollection_location;

      setSelectedRecollectionLocation((prevLocation) =>
        prevLocation.Recollectionlatitude !== recollectionLatitude ||
          prevLocation.Recollectionlongitude !== recollectionLongitude
          ? {
            Recollectionlatitude: recollectionLatitude,
            Recollectionlongitude: recollectionLongitude,
          }
          : prevLocation
      );
    }
  }, [editOrderDetails?.recollection_location]);

  //--------------------------------------------------------

  useEffect(() => {
    if (editOrderDetails) {
      setStatus(editOrderDetails.insurance_order ? "true" : "false");
    }
  }, [editOrderDetails]);

  const [selectedOrderId, setSelectedOrderId] = useState<string>("");
  const [selectedOrderStatus, setSelectedOrderStatus] = useState<string>("");
  const [rejectConfirmationMessage, setRejectConfirmationMessage] =
    useState("");
  const [showModal, setShowModal] = useState(false);
  const handleCancelClick = (orderId: string, orderStatus: string) => {
    setSelectedOrderId(orderId);
    setSelectedOrderStatus(orderStatus);
    setRejectConfirmationMessage(
      "Cancellation charges will apply"
    );
    setShowModal(true);
  };

  const handleCancelOrder = async (orderId: string, orderStatus: string) => {
    try {
      const accessToken = localStorage.getItem("access_token");
      const response = await axiosInstance.put(
        `${API_URL.CUSTOMER_ORDER_CANCEL}`,
        {
          order_number: orderId,
          cancel_reason: "Customer request",
          order_status: orderStatus,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
            language: "english",
            location: "0,0",
          },
        }
      );

      if (response?.status === 200) {
        if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
          ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
        }
        ReactPixel.track("CustomizeProduct", {
          content_type: "order_cancel",
          content_name: "Order Cancelled",
          content_category: "OrderHistory",
          order_id: orderId,
        });
        await trackEvent({
          event_name: {
            web: "Kirkos_OrderHistoryOrderCancel_Success",
            app: "Kirkos_OrderHistoryOrderCancel_Success_App",
          },
          event_category: "OrderHistory_Info",
          module: "OrderHistory",
          payload: { status: "cancelled", order_id: orderId },
        });
        toast.success("Order cancelled successfully");
        navigate("/customer/orders");
      }
    } catch (error) {
      toast.error("Error cancelling order");
      console.error("Error cancelling order:", error);
    }
  };
  //-------------------------------------------

  //===========================================================================
  const [minDateTime, setMinDateTime] = useState("");

  useEffect(() => {
    const now = new Date();
    const isoString = now.toISOString().substring(0, 16);
    setMinDateTime(isoString);
  }, []);

  // const handleDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setDateTime(event.target.value);
  // };
  const handleDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDateTime = event.target.value;
    setDateTime(newDateTime);

    if (selectedSlot) {
      // const datePart = newDateTime.split("T")[0];
      const slotParts = selectedSlot.split("-");
      if (slotParts.length === 2) {
        // const newStartTime = `${datePart}T${slotParts[0].trim()}`;
        // const newEndTime = `${datePart}T${slotParts[1].trim()}`;
        setSelectedSlot(`${slotParts[0].trim()}-${slotParts[1].trim()}`);
      }
    }
  };
  const handleDateTimeReChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newDateTime = event.target.value;
    setRecollectionDateTime(newDateTime);

    if (selectedSlot) {
      // const datePart = newDateTime.split("T")[0];
      const slotParts = selectedSlot.split("-");
      if (slotParts.length === 2) {
        // const newStartTime = `${datePart}T${slotParts[0].trim()}`;
        // const newEndTime = `${datePart}T${slotParts[1].trim()}`;
        setSelectedSlot(`${slotParts[0].trim()}-${slotParts[1].trim()}`);
      }
    }
  };

  const handleDateTimeExtendChange = (
    value: string
  ) => {
    const selectedDateTime = value;

    if (editOrderDetails?.recollection_date) {
      const originalRecollection = new Date(editOrderDetails.recollection_date);

      if (new Date(selectedDateTime) < originalRecollection) {
        toast.error("Recollection date cannot be before the original recollection date.", {
          position: "top-right",
        });
        return;
      }

      const maxAllowed = new Date(editOrderDetails.recollection_date);
      maxAllowed.setDate(maxAllowed.getDate() + 30);
      if (new Date(selectedDateTime) > maxAllowed) {
        toast.error("Recollection date cannot be more than 30 days from the original recollection date.", {
          position: "top-right",
        });
        return;
      }
    }

    setRecollectionDateTime(selectedDateTime);

    const currentRecollectionDate = new Date(
      editOrderDetails?.recollection_date
    );
    const selectedDate = new Date(selectedDateTime);

    if (selectedDate < currentRecollectionDate) {
      // console.log("reduced =", selectedDateTime);
      setDaysModificationType("REDUCE");
    } else if (selectedDate > currentRecollectionDate) {
      // console.log("extended =", selectedDateTime);
      setDaysModificationType("EXTENSION");
    }
  };

  const calculateDaysDifference = () => {
    const currentRecollectionDate = new Date(
      editOrderDetails?.recollection_date
    );
    const selectedDate = new Date(recollectionDateTime);

    const diffTime = Math.abs(
      selectedDate.getTime() - currentRecollectionDate.getTime()
    );
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const remainingTime = diffTime % (1000 * 60 * 60 * 24);

    const hours = Math.floor(remainingTime / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

    const timeStr = hours > 0 || minutes > 0 ? ` ${hours}h ${minutes}m` : '';

    if (selectedDate < currentRecollectionDate) {
      return <span className="text-danger">Days Reduced: {diffDays} days{timeStr}</span>;
    } else if (selectedDate > currentRecollectionDate) {
      return (
        <span className="text-success">Days Extended: {diffDays} days{timeStr}</span>
      );
    }
    return null;
  };

  return (
    <div className="row">
      <div className="col-md-12 text-start div-bg-invoice-details">
        <div className="card card-bg-invoice-details">
          <div className="card-body px-5">
            <div className="row   pb-3">
              <div className="col-md-12 pt-4">
                <table className="invoice-table-width">
                  <tr className="invoice-table-tr-first">
                    <td className="invoice-table-td">Purchase order #</td>
                    <td className="text-end">Order Created At</td>
                  </tr>
                  <tr>
                    <td className="invoice-text-yellow ">
                      # {editOrderDetails?.orderId}
                    </td>
                    <td className="text-end">
                      {formatDate(editOrderDetails?.createdAt)}
                    </td>
                  </tr>
                </table>
                <div className="row">
                  {/* <div className="col-md-12 invoice-div-head pt-3 fs-6 invoice-text-yellow">
                    Order Details
                  </div> */}
                  <div className="col-md-6 pt-3">
                    <label className="form-label dashboard-poppins-font-style">
                      Vehicle
                    </label>
                    <CustomInput
                      inputName="ProductName"
                      inputType="ProductName"
                      editable={false}
                      control={control}
                      className="merchant-input-style-create-product"
                      placeholder="Honda"
                      onInputChange={(value: string) => { }}
                    />
                  </div>
                  {/* {editOrderDetails?.orderStatus === "BOOKED" && !buttonExtend && (
                    <>
                      <div className="col-md-6 pt-3 relative-div">
                        <label className="form-label dashboard-poppins-font-style">
                          Delivery Location
                        </label>
                        <CustomInput
                          inputName="Location"
                          inputType="Location"
                          className="merchant-input-style-create-product"
                          placeholder="Location"
                          editable={true}
                          onInputChange={(value: string) =>
                            handleInputChange(value)
                          }
                          control={control}
                        />
                        {addressSuggestions?.length > 0 && (
                          <div className="absolute-div">
                            <ul
                              className="text-start"
                              style={{ color: "white" }}
                            >
                              {addressSuggestions?.map((suggestion, index) => (
                                <li
                                  key={index}
                                  onClick={() =>
                                    handleSuggestionClick(suggestion)
                                  }
                                >
                                  {suggestion}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 pt-3 relative-div">
                        <label className="form-label dashboard-poppins-font-style">
                          Recollection Location
                        </label>
                        <CustomInput
                          inputName="RecollectionLocation"
                          inputType="Location"
                          className="merchant-input-style-create-product"
                          placeholder="Recollection Location"
                          editable={true}
                          onInputChange={(value: string) =>
                            handleRecollectionInputChange(value)
                          }
                          control={control}
                        />
                        {recollectionAddressSuggestions?.length > 0 && (
                          <div className="absolute-div">
                            <ul
                              className="text-start"
                              style={{ color: "white" }}
                            >
                              {recollectionAddressSuggestions?.map(
                                (suggestion, index) => (
                                  <li
                                    key={index}
                                    onClick={() =>
                                      handleRecollectionSuggestionClick(
                                        suggestion
                                      )
                                    }
                                  >
                                    {suggestion}
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 pt-3">
                        <label className="form-label dashboard-poppins-font-style">
                          Delivery Date
                        </label>
                        <div className="input-date-container">
                          <input
                            type="datetime-local"
                            id="datetime"
                            value={dateTime}
                            onChange={handleDateTimeChange}
                            min={minDateTime}
                            className="merchant-input-style-create-product"
                          />
                        </div>
                      </div>

                      <div className="col-md-6 pt-3">
                        <label className="form-label dashboard-poppins-font-style">
                          Recollection Date
                        </label>
                        <div className="input-date-container">
                          <input
                            type="datetime-local"
                            id="datetime"
                            value={recollectionDateTime}
                            onChange={handleDateTimeReChange}
                            min={minDateTime}
                            className="merchant-input-style-create-product"
                          />
                        </div>
                      </div>
                    </>
                  )} */}

                  <>
                    <div className="col-md-6 pt-3">
                      <OrderEditDateTimePicker
                        label="Extend Recollection Date"
                        dateValue={recollectionDateTime ? recollectionDateTime.split("T")[0] : null}
                        timeValue={recollectionDateTime ? recollectionDateTime.split("T")[1] : null}
                        onConfirm={(dateTime) => {
                          handleDateTimeExtendChange(dateTime);
                        }}
                        minDate={editOrderDetails?.recollection_date ? new Date(editOrderDetails.recollection_date) : null}
                        maxDate={editOrderDetails?.recollection_date ? (() => {
                          const d = new Date(editOrderDetails.recollection_date);
                          d.setDate(d.getDate() + 30);
                          return d;
                        })() : null}
                      />
                      {recollectionDateTime && (
                        <div className="mt-2">
                          {calculateDaysDifference()}
                        </div>
                      )}
                    </div>
                  </>

                </div>
              </div>
              <div className="col-12 pt-4 pb-3">
                <div className="d-flex justify-content-end gap-2 customer-order-edit-actions">
                  <button
                    className="invoice-approve-btn px-4 customer-order-edit-button"
                    style={{ fontSize: "14px" }}
                    onClick={() =>
                      navigate(`/customer/orders`, {

                      })
                    }
                  >
                    Back
                  </button>
                  {(editOrderDetails?.orderStatus === "BOOKED" ||
                    editOrderDetails?.orderStatus === "MERCHANT_ORDER_ACCEPT") && (
                      <button
                        className="btn btn-danger btn-sm px-4 customer-order-edit-button"
                        style={{ fontSize: "14px" }}
                        onClick={() =>
                          handleCancelClick(
                            editOrderDetails.orderId,
                            editOrderDetails.orderStatus
                          )
                        }
                      >
                        Cancel Order
                      </button>
                    )}

                  <button className="invoice-approve-btn px-4 customer-order-edit-button" style={{ fontSize: "14px" }} onClick={handleUpdate}>
                    + <img src={dashboard_invoice_approve} height={"14px"} alt="" />
                    &nbsp;Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onNav={() => {
          navigate("/customer/orders");
          setShowSuccessModal(false);
        }}
        message={"Updated Successfully"}
      />
      <ConfirmationModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={() => {
          handleCancelOrder(selectedOrderId, selectedOrderStatus);
          setShowModal(false);
        }}
        message={rejectConfirmationMessage}
      />
      <ConfirmationModal
        isOpen={showPaymentConfirmModal}
        onClose={() => setShowPaymentConfirmModal(false)}
        onConfirm={() => {
          if (paymentData) {
            navigate("/stripe-payment", {
              state: {
                orderNumber: paymentData.orderNumber,
                amount: paymentData.amount,
                clientSecret: paymentData.clientSecret,
                paymentMerchantInfo: paymentData.paymentMerchantInfo,
                returnPath: `/customer/order/edit?OrderId=${paymentData?.orderNumber}`,
              },
            });
          }
          setShowPaymentConfirmModal(false);
        }}
        message={`Final amount to be paid: AED ${paymentData?.amount || '0.00'}\n\nClick Continue to proceed with the payment.`}
      >
        {paymentData && (paymentData.paiInsuranceAmount > 0 ||
          paymentData.scdwAmount > 0 ||
          paymentData.cdwAmount > 0 ||
          paymentData.additionalDriverAmount > 0 ||
          paymentData.windShieldProtection > 0 ||
          paymentData.babySeatAmount > 0) && (
            <div className="text-message mb-3">
              <h6>Charges:</h6>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                {paymentData.paiInsuranceAmount > 0 && (
                  <li>PAI Insurance: AED {paymentData.paiInsuranceAmount.toFixed(2)}</li>
                )}
                {paymentData.scdwAmount > 0 && (
                  <li>SCDW: AED {paymentData.scdwAmount.toFixed(2)}</li>
                )}
                {paymentData.cdwAmount > 0 && (
                  <li>CDW: AED {paymentData.cdwAmount.toFixed(2)}</li>
                )}
                {paymentData.additionalDriverAmount > 0 && (
                  <li>Additional Driver: AED {paymentData.additionalDriverAmount.toFixed(2)}</li>
                )}
                {paymentData.windShieldProtection > 0 && (
                  <li>Windshield Protection: AED {paymentData.windShieldProtection.toFixed(2)}</li>
                )}
                {paymentData.babySeatAmount > 0 && (
                  <li>Baby Seat: AED {paymentData.babySeatAmount.toFixed(2)}</li>
                )}
              </ul>
            </div>
          )}
      </ConfirmationModal>
      <div className="col-md-12 text-start div-bg-invoice-details mt-4">
        <div className="card card-bg-invoice-details">
          <div className="card-body px-5">
            <div className="row pb-3">
              <div className="col-md-12 pt-4">
                <h5 className="invoice-div-head fs-6 invoice-text-yellow mb-3">
                  <span className="me-2">*</span>
                  Rental Modification Terms
                </h5>
                <ul className="modification-terms-list">
                  {/* <li>
                    If you reduce your rental period by one day within 24
                    hours of acceptance, you will receive a full refund for
                    that day.
                  </li>
                  <li>
                    If you reduce your rental period after 24 hours of
                    acceptance or by more than one day, no refund will be
                    provided.
                  </li> */}
                  <li>
                    If you extend your rental period, the cost for the
                    additional days must be paid.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerorderDetailsEdit;
